import classNames from 'classnames';

type Props = {
    items: string[];
    class?: string;
    className?: string;
};
export function BulletList({ items, class: _class, className }: Props) {
    return (
        <ul className={classNames(className ?? _class, 'list-disc pl-20')}>
            {items.map((x, idx) => (
                <li key={idx}>{x}</li>
            ))}
        </ul>
    );
}
